import React from 'react';
import { useTranslation } from 'react-i18next';
import PromptModal from '../../Popup/PromptModal';
import { getFolderNameValidationErrorMessage, MAX_TITLE_LENGTH, } from '../../utils/isValidFolderName';
import s from './NewCollectionConfirmationPopup.scss';
export var NewCollectionConfirmationPopup = function (_a) {
    var isOpen = _a.isOpen, onCancel = _a.onCancel, onDone = _a.onDone, folderNameBlacklist = _a.folderNameBlacklist;
    var t = useTranslation().t;
    return (React.createElement(PromptModal, { isOpen: isOpen, title: t('collectionPanel.newCollection'), inputWrapperClassName: s['input'], doneButtonLabel: t('collectionPanel.create'), onDone: onDone, onCancel: onCancel, onInputValidate: function (name) {
            return getFolderNameValidationErrorMessage(name, t, folderNameBlacklist, false);
        }, minLength: 1, maxLength: MAX_TITLE_LENGTH, extrasBeforeInput: React.createElement("div", { className: s['hint'] }, t('collectionPanel.typeName')) }));
};
NewCollectionConfirmationPopup.displayName = 'NewCollectionConfirmationPopup';
export default NewCollectionConfirmationPopup;
//# sourceMappingURL=NewCollectionConfirmationPopup.js.map